function clone(a) {
  return JSON.parse(JSON.stringify(a));
}

function ValidateServer(server) {
  return server && server.cpu && server.cpuNum && server.ram && server.disks && server.disks.length > 0 && server.price;
}

function ValidateServers(servers) {
  let _servers = [];

  for (const server of servers) {
    if (!ValidateServer(server)) continue;

    let tags = {};

    let diskindex = 0;
    let _disks = [];
    for (const disk of server.disks) {
      if (disk.type == "ssd") tags.SSD = true;
      if (disk.interface == "nvme") tags.NVMe = true;

      const _disk = clone(disk);
      _disk.index = diskindex++;
      _disks.push(_disk);
    }
    server.disks = _disks;

    let gpuIndex = 0;
    let _gpus = [];
    for (const gpu of server.gpus) {
      const _gpu = clone(gpu);
      _gpu.index = gpuIndex++;
      _gpus.push(_gpu);
    }
    if (_gpus.length) tags.GPU = true;
    if (tags.NVMe) delete tags.SSD;

    server.tags = Object.keys(tags);
    _servers.push(server);
  }
  return _servers;
}

export { ValidateServers };
export { ValidateServer };
